import './css/layout.scss';

require('overlayscrollbars');

document.addEventListener('DOMContentLoaded', function () {
  OverlayScrollbars(document.querySelectorAll('#content-container'), {
    className: 'os-theme-dark',
  });
});
